import { FC, ReactElement } from 'react';

import { SafeHtml } from '../../components';
import { useTrans } from '../../hooks';

import './RecaptchaDisclaimer.scss';

interface RecaptchaDisclaimerProps {
    className?: string;
}

export const RecaptchaDisclaimer: FC<RecaptchaDisclaimerProps> = ({
    className = '',
}): ReactElement => {
    const trans = useTrans();

    return (
        <SafeHtml
            html={trans('compositions.recaptchaDisclaimer.disclaimer')}
            className={`recaptcha-disclaimer ${className}`}
        />
    );
};
